import React from 'react';
import { motion } from 'framer-motion';
import { EASE } from './Reveal';

/*
  Masked word-by-word reveal for headlines.
  Pass `text` as a string; wrap accent words in *asterisks* to style them (serif italic + gradient).
  Use "|" to force a line break.
*/
export default function SplitText({ text, as = 'h1', className, delay = 0, stagger = 0.06, inView = false }) {
  const Tag = motion[as] || motion.h1;
  const lines = text.split('|');
  let i = 0;
  let inAccent = false; // supports multi-word accents like *PMC excellence*
  const trigger = inView
    ? { initial: 'hidden', whileInView: 'show', viewport: { once: true, amount: 0.5 } }
    : { initial: 'hidden', animate: 'show' };
  return (
    <Tag className={className} {...trigger} aria-label={text.replace(/[*|]/g, ' ').replace(/\s+/g, ' ')}
      variants={{ hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}>
      {lines.map((line, li) => (
        <span key={li} className="split-line" aria-hidden="true">
          {line.trim().split(' ').map((raw) => {
            if (raw.startsWith('*')) inAccent = true;
            const accent = inAccent;
            if (raw.endsWith('*')) inAccent = false;
            const word = raw.replace(/\*/g, '');
            i += 1;
            return (
              <span className="split-mask" key={`${li}-${i}`}>
                <motion.span className={`split-word${accent ? ' accent' : ''}`}
                  variants={{ hidden: { y: '115%', rotate: 6 }, show: { y: '0%', rotate: 0, transition: { duration: 1, ease: EASE } } }}>
                  {word}
                </motion.span>
              </span>
            );
          })}
        </span>
      ))}
    </Tag>
  );
}
